module.exports = __webpack_public_path__ + "static/media/13.91820480.jpg";